import ProductTransformer from './ProductTransformer';

export default class StockProductTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteMyProducts' && product.productOptions && product.productOptions.some(o => o.status === 'active')) {
      // SubscriptionStatus is 2 or 3
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'minimumCommitmentPeriodOverrideTextMyProducts',
      'minimumCommitmentPeriodTextMyProducts',
      'productType',
      'optinPossibleShortInfo',
      'optinPossibleLongInfo',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
    if (product.productOptions) {
      product.productOptions.forEach(po => {
        po.subscriptionDescriptions.forEach(item => {
          if (item.kind === 'html') item.text = footnotes.parse(item.text);
        });
      });
    }
    [
      'hintMyProducts',
      'orderCancellationQuestion',
      'orderCancellationDateQuestion',
      'orderTerminationQuestion',
      'orderReservationDeletionQuestion',
      'orderReactivationQuestion',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
